import React, { useEffect, useRef, useState } from "react";
import { callingCode } from "../../../../helpers/helper";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getGuestDetails,
  getLoading,
  getRoomBooked,
  hotelBookAsync,
  selectHotelRoomAsync,
  setCounts,
} from "../../../../features/bookings/hotelSlice";
import SuccessModal from "../../../modals/SuccessModal";
import Loader from "../../../../helpers/Loader";
import { useForm } from "../../../../hooks/useForm";
import {
  useNavigate,
  useSearchParams,
  createSearchParams,
} from "react-router-dom";
import { errorToast } from "../../../../helpers/toaster";

const HotelGuestForm = ({
  code,
  val,
  total,
  guests,
  checkIn,
  checkOut,
  match,
}) => {
  const [myGuests, setGuests] = useState({});
  const [show, setShow] = useState(false);
  const [dyncErrors, setDyncErrors] = useState({});
  const [statusCode, setStatusCode] = useState("");
  const selectRooms = useSelector(
    (state) => state.hotel.SelectRoom,
    shallowEqual
  );
  const selectRoomStat = useSelector(
    (state) => state.hotel.selectRoomStatus,
    shallowEqual
  );

  console.log("selectRoomStat", selectRoomStat);

  // const singleHotelPrice = useSelector(getsingleHotelPrice);

  const { pricedata } = val || {};

  const navigate = useNavigate();

  const [customers, setCustomers] = useState([]);

  const [searchParams] = useSearchParams();

  const [queryData, setQueryData] = useState(
    Object.fromEntries([...searchParams])
  );

  const Rooms = JSON.parse(queryData.guestDetails);

  const checkRef = React.useRef(true);

  const [change, setChange] = useState(false);

  const customValidate = () => {
    let errors = {};
    customers.map((ele, ind) => {
      errors[ind] = [];
      ele.forEach((guest, i) => {
        errors[ind][i] = {};
        if (guest.FirstName.trim() === "") {
          errors[ind][i].FirstName = "First Name Is Required!";
        }

        if (guest.LastName.trim() === "") {
          errors[ind][i].LastName = "Last Name Is Required!";
        }

        if (guest.Title.trim() === "") {
          errors[ind][i].Title = "Title Is Required!";
        }
      });

      errors[ind] = errors[ind].filter((ele) => Object.keys(ele).length > 0);
    });

    if (errors[0].length === 0) {
      setDyncErrors({});
    } else {
      setDyncErrors(errors);
    }
  };

  const {
    state,
    setState,
    isSubmit,
    formErrors,
    handleInputChange,
    handleFormSubmit,
    checkErrors,
    // handleInputDynamic,
    // checkDyncErrors,
  } = useForm({
    val: {
      Email: "",
      MobileNo: "",
      CountryCode: "",
    },
    // dyncVals: {
    //   items: customers,
    //   setItems: setCustomers,
    //   arrItems: ["Title", "FirstName", "LastName"],
    // },
    // inValidate: customValidate,
    withSubmit: customValidate,
  });
  // const [state, setState] = useState({
  //   email: "",
  //   mobile: "",
  //   countryCode: "",
  // });
  // const [formErrors, setFormErrors] = useState({});
  // const [isSubmit, setIsSubmit] = useState(false);
  // const []

  const [etc, setEtc] = useState(false);

  const [status, setStatus] = useState("");
  const [msg, setMsg] = useState("");

  const dispatch = useDispatch();
  const bookingStatus = useSelector(getRoomBooked);

  const loading = useSelector(getLoading);
  const backErrors = useSelector((state) => state.hotel.errors, shallowEqual);
  const preBooked = useSelector((state) => state.hotel.preBooked, shallowEqual);

  const SelectRoom = useSelector(
    (state) => state.hotel.SelectRoom,
    shallowEqual
  );

  const statusCodes = useSelector((state) => state.hotel.status, shallowEqual);

  const { Authorization } =
    JSON.parse(sessionStorage.getItem("userData")) || {};

  useEffect(() => {
    if (bookingStatus === false) {
      if (parseInt(statusCodes) === 300) {
        setMsg("Your booking is under process.");
      } else {
        setMsg("Something went wrong try after sometime");
      }
      setShow(true);
      setStatusCode(statusCodes);
    }

    if (Object?.keys(bookingStatus).length > 0) {
      if (bookingStatus) {
        setStatusCode(statusCodes);
        setMsg(
          "Your booking has been Confirmed. Check your emails for details."
        );
        // setStatus("Awesome!");
      } else {
        if (parseInt(statusCodes) === 300) {
          setMsg("Your booking is under process.");
        } else {
          setMsg("Something went wrong try after sometime");
        }
        // setStatus("Failed!");
      }
      setShow(true);
    }
  }, [bookingStatus]);

  useEffect(() => {
    if (queryData?.length > 0) {
      const sessionData = JSON.parse(sessionStorage.getItem("hotelForm"));

      const guestDetails = JSON.parse(sessionData.guestDetails);

      dispatch(setCounts(guestDetails));
    }
  }, [queryData]);

  useEffect(() => {
    if (!preBooked) {
      // errorToast("Session Expired!");

      setStatusCode(400);
      setMsg(SelectRoom.message);
      setShow(true);
      // {
      //   navigate({
      //     pathname: "/hotel-details",
      //     search: `${createSearchParams(queryData)}`,
      //   });
      // }
    }
  }, [preBooked]);

  useEffect(() => {
    val.TotalFare !== undefined > 0 &&
      setState({
        ...state,
        BookingCode: code,
        TotalFare: total,
        hotelId: val.id,
      });
  }, [val, total]);

  useEffect(() => {
    setGuests(guests);
    // dispatch(selectHotelRoomAsync({ code, Authorization }));

    let arr = [];
    Rooms.forEach((ele, ind) => {
      arr[ind] = [];
      for (let index = 0; index < ele.Adults; index++) {
        arr[ind].push({
          FirstName: "",
          LastName: "",
          Type: "Adult",
          Title: "",
        });
      }
      for (let index = 0; index < ele.Children; index++) {
        arr[ind].push({
          FirstName: "",
          LastName: "",
          Type: "Child",
          Title: "",
        });
      }
    });
    setCustomers(arr);
  }, []);

  useEffect(() => {
    if (
      Object.keys(formErrors).length === 0 &&
      isSubmit &&
      Object.keys(dyncErrors).length === 0
    ) {
      let Obj = { state, customers };
      dispatch(
        hotelBookAsync({
          Obj,
          Authorization,
          selectedRoom: SelectRoom?.data?.[0],
          checkIn,
          checkOut,
        })
      );
    }
  }, [formErrors]);

  const checkDyncErrors = (e, index, outInd) => {
    let name = e.target.name.split("[]")[0];
    let obj = dyncErrors;

    // if (dyncErrors[outInd] !== undefined) {
    //   obj = dyncErrors[outInd][index]
    // } else {
    //   obj = {};
    // }

    if (e.target.value.trim() === "") {
      dyncErrors[outInd] !== undefined
        ? (obj[outInd] = dyncErrors[outInd])
        : (obj[outInd] = {});

      dyncErrors[outInd][index] !== undefined
        ? (obj[outInd][index] = dyncErrors[outInd][index])
        : (obj[outInd][index] = {});

      let msg = name.split(/(?=[A-Z])/);
      if (msg.length > 1) {
        msg = msg.join(" ");
      }

      obj[outInd][index][name] = `${msg} Is Required!`;
    } else {
      if (dyncErrors[outInd]?.[index]?.[name] !== undefined) {
        delete dyncErrors[outInd][index][name];
      }
    }

    setDyncErrors(obj);
    setChange(!change);
  };

  const handleDynamicInput = (e, ind, outInd) => {
    let name = e.target.name.split("[]")[0];

    customers[outInd] !== undefined
      ? (customers[outInd] = customers[outInd])
      : (customers[outInd] = {});

    customers[outInd][ind] !== undefined
      ? (customers[outInd][ind] = customers[outInd][ind])
      : (customers[outInd][ind] = {});

    customers[outInd][ind][name] = e.target.value;

    setCustomers(customers);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="review-booking-wrapper guest-details-wrapper guest-details-adults">
        <form className="guest-detail-form">
          {customers.map((ele, outInd) => {
            return (
              <div key={outInd} className="room-guest-detail">
                <h5> Room {outInd + 1} </h5>
                <h4>{match?.["Name"]?.[outInd]}</h4>
                {ele.map((guest, index) => {
                  return (
                    <div key={index}>
                      <h5>
                        <span>{guest.Type}</span>{" "}
                      </h5>
                      <div className="name-detail">
                        <div className="form-group">
                          <label htmlFor="">Title</label>
                          <select
                            name="Title[]"
                            className="form-control"
                            onChange={(e) =>
                              handleDynamicInput(e, index, outInd)
                            }
                            onBlur={(e) => checkDyncErrors(e, index, outInd)}
                            autoComplete="off"
                          >
                            <option value="">Title</option>
                            <option value="Mr.">Mr</option>
                            <option value="Ms.">Ms</option>
                            <option value="Mrs.">Mrs</option>
                          </select>

                          <span className="error">
                            {dyncErrors?.[outInd]?.[index]?.Title}
                          </span>
                        </div>
                        {/*  */}
                        <div className="form-group">
                          <label htmlFor="">First Name</label>
                          <input
                            type="text"
                            className="firstName"
                            placeholder="Enter First Name"
                            name="FirstName[]"
                            onChange={(e) =>
                              handleDynamicInput(e, index, outInd)
                            }
                            onBlur={(e) => checkDyncErrors(e, index, outInd)}
                            autoComplete="off"
                          />
                          <span className="error">
                            {dyncErrors?.[outInd]?.[index]?.FirstName}
                          </span>
                        </div>
                        {/*  */}
                        <div className="form-group">
                          <label htmlFor="">Last Name</label>
                          <input
                            type="text"
                            placeholder="Enter Last Name"
                            name="LastName[]"
                            onChange={(e) =>
                              handleDynamicInput(e, index, outInd)
                            }
                            onBlur={(e) => checkDyncErrors(e, index, outInd)}
                            autoComplete="off"
                          />
                          <span className="error">
                            {dyncErrors?.[outInd]?.[index]?.LastName}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}

          <div className="row">
            <div className="col-lg-8">
              <div className="form-group ">
                <label htmlFor="">
                  Email Address{" "}
                  <span className="medium14">
                    (Your booking voucher will be sent to this email address)
                  </span>
                </label>
                <input
                  type="email"
                  placeholder="Enter Email Address"
                  value={state.Email}
                  name="Email"
                  onChange={handleInputChange}
                  // onBlur={(e) => setSingleError(e)}
                  onBlur={(e) => checkErrors(e)}
                  autoComplete="off"
                  // onFocus={(e) => setErrors(e)}
                />
              </div>
              <span className="error">{formErrors?.Email}</span>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 p-0">
            <div className="mobile-number">
              <div className="form-group">
                <label for="">Mobile Number </label>
                <div>
                  <div className="position-relative select-country-code">
                    <div className="select-arrow"></div>
                    <select
                      name="CountryCode"
                      className="form-control"
                      // onFocus={(e) => setErrors(e)}
                      autoComplete="off"
                      // onBlur={(e) => setSingleError(e)}
                      onBlur={(e) => checkErrors(e)}
                      onChange={handleInputChange}
                    >
                      <option value="">code</option>
                      {callingCode.map((ele, ind) => (
                        <option key={ind} value={ele.value}>
                          {ele.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <input
                    type="text"
                    placeholder="Enter Mobile Number"
                    name="MobileNo"
                    value={state.MobileNo}
                    onChange={handleInputChange}
                    autoComplete="off"
                    onBlur={(e) => checkErrors(e)}
                    // onFocus={(e) => setErrors(e)}
                    // onBlur={(e) => setSingleError(e)}
                  />
                  <br />
                </div>
                <span className="error">{formErrors?.CountryCode}</span>
                <span className="error">{formErrors?.MobileNo}</span>
              </div>
            </div>
          </div>

          {/*  */}
          <div className="text-center border-top-0">
            <button
              className="cmn-btn reserve-btn d-block w-100"
              type="submit"
              onClick={handleFormSubmit}
              disabled={selectRoomStat ? false : true}
            >
              {selectRoomStat ? "Book & Pay" : "Selecting Room"}
            </button>
          </div>
        </form>

        {show ? (
          <SuccessModal
            setShow={setShow}
            show={show}
            msg={msg}
            status={status}
            statusCode={statusCode}
          />
        ) : null}
      </div>
    </>
  );
};

export default HotelGuestForm;
